import BackdropUI from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import {styled} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';

// Styles
const Backdrop = styled(BackdropUI)(({theme}) => ({
  zIndex: theme.zIndex.modal,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  backdropFilter: 'blur(5px)',
}));

const LoadingBackdrop = ({open}) => {
  const {t} = useTranslation();
  return (
    <Backdrop open={open}>
      <Box textAlign="center">
        <CircularProgress />
        <Typography variant="subtitle1">
          {t('snapshotBackdrop.generating', 'Generating Snapshot...')}
        </Typography>
      </Box>
    </Backdrop>
  );
};

LoadingBackdrop.propTypes = {
  open: PropTypes.bool,
};

export default LoadingBackdrop;
